import React, {useState, useEffect, useRef} from "react";
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";

const AssignQuotePopupContentHoc = (props) => {

  const [contentDimensions, setContentDimensions] = useState(null);
  const assContentElement = useRef(null);
  const {windowWidth, children, className} = props;

  const setCurrentContentDimensions = () => {
    if (assContentElement && assContentElement.current && assContentElement.current.clientWidth) {
      const isMobile = windowWidth < 991;
      // console.log("cellElement.current.clientWidth", assContentElement.current.clientWidth);
      setContentDimensions({
        width: isMobile ? assContentElement.current.clientWidth : null,
        height: isMobile ? assContentElement.current.clientHeight : null,
      });
    }
  }

  useEffect(() => {
    setCurrentContentDimensions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [windowWidth, assContentElement]);

  // console.log("contentWidth", contentWidth);

  return (
    <div className={className || "ass-content"} ref={assContentElement}>
      {children(contentDimensions)}
    </div>
  )
};

AssignQuotePopupContentHoc.propTypes = {
  children: PropTypes.func.isRequired,
  className: PropTypes.string,
};

const mapStateToProps = () => {
  return {
    windowWidth: window.innerWidth,
  };
};

const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AssignQuotePopupContentHoc)
)
